import React, { useState } from 'react';
import SVG from 'react-inlinesvg';
import SearchBar from './SearchBar';
import RightSidebarPanel from './RightSidebarPanel';
import useAuth from '../context/AuthContext';
import useResponsive from '../hooks/useResponsive';
import { getAlexUrl } from '../helpers/getAlexUrl';
import ChatBubbleIcon from '../../../../assets/images/reskin-images/icon--chat-with-alex.svg';
import SidebarLogoIcon from '../../../../assets/images/reskin-images/playbook-full-logo.png';
import SidebarSmallLogoIcon from '../../../../assets/icons/logo-small.svg';
import Button from './Button';
import Container from './Container';



export const SidebarHeaderLogoIcon = ({ isMobile }) => {
  const { isLg } = useResponsive()

  return (
    <a href='https://admiredleadership.com'>
      {isLg? (
        <img
          style={{
            maxHeight: isMobile ? '36px' : '32px',
          }}
          src={SidebarLogoIcon}
          alt="Admired Leadership Logo"
          className="-mb-2"
          />
      ) : (
        <SVG src={SidebarSmallLogoIcon} alt="Admired Leadership Small Logo" className="fill-current"/>
        
      )}
    </a>
  );
};

export default function HeaderBar() {
  const { userData, isTenant, isLoggedIn } = useAuth();
  const { isTablet, isMobile, isMd } = useResponsive();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const showChat = isLoggedIn && !isTenant && userData?.is_alex_available;
  
  if(!userData) {
    return (
      
      <header
        style={{
          transition: '0.1s all linear',
        }}
        className="relative w-full"
        id="v2-header"
      >
        <Container
          borderBottom
          style={{minHeight: "98px"}}
          className="full-screen-container flex items-center justify-between"
        >

          <SidebarHeaderLogoIcon isMobile={isMobile} />

          <div className="flex items-center ml-auto" style={{ gap: '36px' }}>
            {!isTenant && (
              <p
                className="hide-label font-bold"
                style={{ fontSize: '14px' }}
              >
                <a
                  href="/v2"
                  className="font-bold"
                  style={{ color: '#3C3C3C' }}
                >
                  Get Full Access
                </a>
              </p>
            )}
            <Button
              href={`${
                isTenant
                  ? '/users/sign_in'
                  : (window.ENV?.SSO_CLIENT || 'https://sso.admiredleadership.com') + '/access'

              }`}
              variant="default-lowercase"
              className="font-bold"
              style={{ borderRadius: '16px' }}
            >
              Log In
            </Button>
          </div>
        </Container>
      </header>
    )
  }
  
  return (
    <>
      <div className="flex w-full py-6 items-center justify-between bg-white border-b border-gray">
        {isMd ? (
          <div
            className={`flex items-center px-6 h-full flex-grow md:flex-grow-0 ${
              (!isTablet && !isMobile) ? 'border-r border-gray' : ''
            }`}
          >
            <SearchBar />
          </div>
        ) : (
          <a 
            href='https://admiredleadership.com'
            target="_blank"
            rel="noopener noreferrer"
            className='pl-6'
          >
            <img
              style={{
                maxHeight: isMobile ? '36px' : '32px',
              }}
              src={SidebarLogoIcon}
              alt="Admired Leadership Logo"
            />
          </a>
        )}
        
        <div className='flex flex-row px-6 gap-4'>
          {showChat && (
            <div className="flex items-center h-full">
              <a
                href={getAlexUrl()}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center px-4 py-4 md:py-1 text-white font-bold rounded-xl md:rounded-lg shadow-md hover:opacity-90 transition-opacity no-underline whitespace-nowrap text-sm bg-link-purple hover:bg-purple-500"
              >
                <SVG
                  src={ChatBubbleIcon}
                  className="w-5 h-5 mr-2 text-white"
                />
                <span className="normal-case">
                  {isMd ? (
                    <>
                      Chat with ALEX
                    </>
                  ) : (
                    <>
                      ALEX
                    </>
                  )}
                </span>
              </a>
            </div>
          )}

          { !isMd && (
            <button
              type="button"
              className="h-9 w-9 flex justify-center items-center cursor-pointer"
              onClick={() => setIsSidebarOpen(true)}
            >
              <div className="h-4 flex flex-col justify-between px-3">
                <span style={{ height: '2px' }} className="w-5 rounded bg-black" />
                <span style={{ height: '2px' }} className="w-5 rounded bg-black" />
                <span style={{ height: '2px' }} className="w-5 rounded bg-black" />
              </div>
            </button>
          )}
        </div>
      </div>

      {!isMd && (
        <RightSidebarPanel
          isOpen={isSidebarOpen}
          onClose={() => setIsSidebarOpen(false)}
        />
      )}
    </>
  );
}
